import type { ReactNode } from 'react';
import { MapTrifoldIcon } from '@phosphor-icons/react';
import { Button } from '@voll-intelligence/ui-kit/ui/button';

/** Onde o botão pousa: no pé da lista, grudado ao fim do scroller (`sticky`, o aside fora da
 *  linha do `ResultsLayout`), ou por cima da folha cheia do palco map-centric (`overlay`). */
const PLACEMENT = {
  sticky: 'sticky z-30 mt-4',
  overlay: 'absolute inset-x-0',
} as const;

/**
 * O botão flutuante `Mapa` dos resultados — o MESMO controle nos dois pousos (`PLACEMENT`), para
 * não voltarem a divergir (#6186).
 *
 * A régua é a do Figma (nó 6286:88861, a tela de carro no iPhone 13): 48px de altura, ~94 de
 * largura, base a 32px da borda de baixo. O corpo é o degrau `xl` do DS (texto de 15px, ícone 16,
 * vão 8, respiro 12/16 — ~93 de largura) com a altura levada aos 48 do desenho, acima do degrau
 * de toque de 44. A base fica a 2rem da borda, ou a 1rem acima da área segura quando ela é maior
 * (o indicador de início do iPhone): nunca sobre ela.
 *
 * O embrulho é `pointer-events-none` e só o botão recebe o toque: os lados dele seguem sendo do
 * que está embaixo (o card da lista, #6185).
 */
export function MapFab({
  label,
  placement,
  onOpen,
}: {
  readonly label: string;
  readonly placement: keyof typeof PLACEMENT;
  readonly onOpen: () => void;
}): ReactNode {
  return (
    <div
      className={`pointer-events-none ${PLACEMENT[placement]} bottom-[max(2rem,calc(1rem_+_env(safe-area-inset-bottom,0px)))] flex justify-center`}
    >
      <Button
        type="button"
        size="xl"
        className="pointer-events-auto h-12 rounded-full shadow-lg"
        onClick={onOpen}
      >
        <MapTrifoldIcon data-icon="inline-start" aria-hidden="true" />
        {label}
      </Button>
    </div>
  );
}
